const supportedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'svg', 'txt'];

export function isSupportedFileExtension(fileExtension?: string): boolean {
    if (!fileExtension) return false;
    return supportedExtensions.includes(fileExtension);
}
